import React from 'react';
import * as ROUTES from '../../../../router/Routes';
import ContainerTemplate from '../../../../widgets/template/Container';
import PanelEntidadesView from './PanelEntidadView';

const PanelEntidadesModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.panelEntidad}
      routes={[ROUTES.root, ROUTES.entidades]}
    >
      <PanelEntidadesView />
    </ContainerTemplate>
  );
};

export default PanelEntidadesModule;
